import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";

import "./HomeServicesCard.css";
import service1 from "../Assets/HomeServiceImages/1H_Front end Billing Services.jpg";
import service2 from "../Assets/HomeServiceImages/2H_Medical Coding.jpg";
import service3 from "../Assets/HomeServiceImages/3H_Backend RCM Service.jpg";
import service4 from "../Assets/HomeServiceImages/4H_Provider Credentialing.jpg";
import service5 from "../Assets/HomeServiceImages/5H_Specialty focused end to end Medicail Billing Services.png";
import service6 from "../Assets/HomeServiceImages/6H_Tele medicine Services.png";
import service7 from "../Assets/HomeServiceImages/7H_Analytics & Reporting.png";
import service8 from "../Assets/HomeServiceImages/8H_Technology & Software Support.png";

const HomeServicesCard = () => {
  const services = [
    {
      title: "  Front end Billing services",
      description: "  Front end Billing services",
      buttonText: "  Front end Billing services",
      imageUrl: service1,
      points: [
        "Patient registration, Appointment scheduling and demography creation",
        "Insurance verification and eligibility checks",
        "Charge entry, Charge reconciliation and claim generation",
        "Claim submission (electronic & paper) - Claim scrubbing, Claim Rejection & Edit resolution",
        "Prior authorization management (Pre visit)",
      ],
    },
    {
      title: " Coding & Compliance",
      description: " Coding & Compliance",
      buttonText: " Coding & Compliance",
      imageUrl: service2,
      points: [
        "Medical coding (CPT, ICD-10, HCPCS)",
        "Certified coding audits (by CPC, CCS, etc.)",
        "Upcoding and downcoding prevention",
        "Compliance with HIPAA, CMS, and OIG guidelines",
        "Documentation review and improvement",
        "Risk adjustment coding (HCC, RAF scoring)",
        "MACRA, MIPS, and value-based care reporting",
      ],
    },
    {
      title: " Backend RCM services",
      description: " Backend RCM services",
      buttonText: " Backend RCM services",
      imageUrl: service3,
      points: [
        "Payment posting (ERA & manual posting)",
        "Cash Reconciliation",
        "Credit Balance and Refunds",
        "Correspondence and Adjustments",
        "Assistance with balance billing",
        "Accounts receivable (A/R) follow-up",
        "Prior authorization follow ups",
        "Denial management and appeals",
        "Patient billing and statements",
        "Collections management",
        "Appeal for underpaid claims",
        "Worker's compensation & Personal injury claims",
        "Support in backlog clearance & emergency support during staffing shortage",
      ],
    },
    {
      title: " Credentialing & Provider Enrollment",
      description: " Credentialing & Provider Enrollment",
      buttonText: " Credentialing & Provider Enrollment",
      imageUrl: service4,
      points: [
        "Provider enrollment with payers (Medicare, Medicaid, Commercial payers)",
        "Recredentialing and provider updates",
        "Indexing provider credential documents",
      ],
    },

    {
      title: " Specialty focused end to end Medical Billing Services",
      description: " Specialty focused end to end Medical Billing Services",
      buttonText: " Speciality focused RCM services",
      imageUrl: service5,
      points: [
        "Billing for specific medical specialties (e.g., radiology, cardiology, mental health, urgent care)",
        "Durable Medical Equipment (DME) billing",
        "Laboratory and pathology billing",
        "Ambulatory surgical center (ASC) billing",
      ],
    },
    {
      title: " Telemedicine Billing Services",
      description: " Telemedicine Billing Services",
      buttonText: " Telemedicine Billing Services",
      imageUrl: service6,
      points: [
        "Coding and billing for virtual visits",
        "Compliance with telehealth regulations",
        "Reimbursement optimization for telehealth services",
      ],
    },
    {
      title: " Analytics & Reporting",
      description: " Analytics & Reporting",
      buttonText: " Analytics & Reporting",
      imageUrl: service7,
      points: [
        "Customized financial reports",
        "KPI tracking and benchmarking",
        "Denial analysis and reduction strategies",
        "Revenue cycle performance monitoring",
      ],
    },
    {
      title: " Technology & Software Support",
      description: " Technology & Software Support",
      buttonText: " Technology & Software Support",
      imageUrl: service8,
      points: [
        "Medical billing software integration (e.g., with EHR/EMR)",
        "Cloud-based billing solutions",
        "Tailored applications like RCM Scorecard handy for the Clevel team, ToDoRCM for daily task management between onshore and offshore business associates, and a lot further through our strategic partner RCMSUMMIT.COM",
      ],
    },
  ];

  const navigate = useNavigate();

  const handleNavigate = (service) => {
    // Navigate to the Services page
    navigate("/homeservices", { state: { targetHeading: service } });
  };

  return (
    <div style={{ backgroundColor: "#1A004C" }}>
      <Container fluid className="HomeServicesCard-container">
        <Row>
          {services.map((service) => (
            <Col xs={12} md={6} className="mb-4" key={service.title}>
              {" "}
              {/* Use unique service.title as key */}
              <Card className="HomeServicesCard-card mt-3">
                <Card.Img
                  variant="top"
                  src={service.imageUrl}
                  alt={service.title}
                  className="HomeServicesCard-image"
                />
                <Card.Body>
                  <Card.Subtitle className="mb-2 text-muted">
                    {service.title}
                  </Card.Subtitle>
                  <Button
                    variant="light"
                    className="HomeServicesCard-button"
                    onClick={() => handleNavigate(service)}
                  >
                    {service.buttonText} <FaArrowRight />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default HomeServicesCard;
